import { useEffect, useState } from 'react';
import { getSettings } from '../../../api/settings';

const DEFAULT_DROPDOWN_SIZE = 10;
const MIN_DROPDOWN_SIZE = 5;

// Cacheado a nivel de módulo: todas las instancias de SnomedPicker en la misma página
// comparten un único request a /clientsettings en vez de dispararlo cada una por su cuenta.
let cachedSizePromise = null;

const fetchDropdownSize = async () => {
    try {
        const res = await getSettings();
        const mrsettings = res.data && JSON.parse(res.data.mrdata);
        const raw = mrsettings?.find(x => x.key === "AutocompleteDropdownSize")?.value;
        const parsed = parseInt(raw, 10);

        return Number.isFinite(parsed) && parsed >= MIN_DROPDOWN_SIZE ? parsed : DEFAULT_DROPDOWN_SIZE;
    } catch (error) {
        // Degradación con gracia (§5): si falla la carga de config, se usa el default fijo.
        console.error('useAutocompleteDropdownSize: fallback to default', error);
        return DEFAULT_DROPDOWN_SIZE;
    }
};

export const useAutocompleteDropdownSize = () => {
    const [dropdownSize, setDropdownSize] = useState(DEFAULT_DROPDOWN_SIZE);

    useEffect(() => {
        let isSubscribed = true;

        if (!cachedSizePromise)
            cachedSizePromise = fetchDropdownSize();

        cachedSizePromise.then(size => {
            if (isSubscribed)
                setDropdownSize(size);
        });

        return () => { isSubscribed = false; };
    }, []);

    return dropdownSize;
};
